import React, { useEffect, useState } from 'react'
import {
  faDroplet,
  faFlaskVial,
  faFolder,
  faIndustry,
  faLeaf,
  faTag,
} from '@fortawesome/free-solid-svg-icons'
import { ItensPerUserLogged } from '../../../../../../../../services/login/permissaoUsuarioLoado'
import Input from '../../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import TextArea from '../../../../../../../../Components/CustomUi/textarea'
interface PropsFormDadosInsumo {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  categoria_insumo: string
  setCategoria_insumo: React.Dispatch<React.SetStateAction<string>>
  setCategoria_insumoId: React.Dispatch<React.SetStateAction<number>>
  classeAgro: string
  setClasseAgro: React.Dispatch<React.SetStateAction<string>>
  setClasseAgroId: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricanteId: React.Dispatch<React.SetStateAction<number>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacaoId: React.Dispatch<React.SetStateAction<number>>
  unidadeDose: string
  setUnidadeDose: React.Dispatch<React.SetStateAction<string>>
  setUnidadeDoseId: React.Dispatch<React.SetStateAction<number>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  dataCatProduto: any[]
  dataCatCategoria: any[]
  dataFabricantes: any[]
  dataFormulacao: any[]
  dataUnidadeMedida: any[]
  handleChangeClasse: Function
  permissions: ItensPerUserLogged
}

export const FormDadosInsumo: React.FC<PropsFormDadosInsumo> = ({
  nome,
  setNome,
  categoria_insumo,
  setCategoria_insumo,
  setCategoria_insumoId,
  classeAgro,
  setClasseAgro,
  setClasseAgroId,
  fabricante,
  setFabricante,
  setFabricanteId,
  formulacao,
  setFormulacao,
  setFormulacaoId,
  unidadeDose,
  setUnidadeDose,
  setUnidadeDoseId,
  observacao,
  setObservacao,
  dataCatProduto,
  dataCatCategoria,
  dataFabricantes,
  dataFormulacao,
  dataUnidadeMedida,
  handleChangeClasse,
  permissions
}) => {
  const [openCategoriaInsumo, setOpenCategoriaInsumo] = useState(false)
  const [openClasse, setOpenClasse] = useState(false)
  const [openFabricante, setOpenFabricante] = useState(false)
  const [openFormulacao, setOpenFormulacao] = useState(false)
  const [openUnidadeDose, setOpenUnidadeDose] = useState(false)

  return (
    <>
      <Input
        label='Nome'
        placeholder='Digite o nome do catálogo de insumo'
        value={nome}
        onChange={setNome}
        icon={faTag}
      />
      <div className='campo__dois__inputs'>
        {/* <Select
          label='Categoria do insumo'
          placeholder='Selecione a categoria do insumo'
          icon={faFolder}
          value={categoria_insumo}
          onChange={setCategoria_insumo}
          onChangeID={setCategoria_insumoId}
          open={openCategoriaInsumo}
          trigger={setOpenCategoriaInsumo}
          items={dataCatProduto}
          descricaoItem={'nome'}
          idItem={'cod'}
        /> */}
        <Select
          label='Classe agronômica'
          placeholder='Selecione a classe agronômica'
          icon={faLeaf}
          value={classeAgro}
          onChange={setClasseAgro}
          onChangeID={(e) => handleChangeClasse(e)}
          open={openClasse}
          trigger={setOpenClasse}
          items={dataCatCategoria}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
      </div>
      <Select
        label='Fabricante'
        placeholder='Selecione o fabricante'
        value={fabricante}
        icon={faIndustry}
        onChange={setFabricante}
        onChangeID={setFabricanteId}
        open={openFabricante}
        trigger={setOpenFabricante}
        items={dataFabricantes}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
      <Select
        label='Formulação'
        placeholder='Selecione a formulação'
        value={formulacao}
        icon={faFlaskVial}
        onChange={setFormulacao}
        onChangeID={setFormulacaoId}
        open={openFormulacao}
        trigger={setOpenFormulacao}
        items={dataFormulacao}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
      <Select
        label='Unidade dose'
        placeholder='Selecione a unidade dose'
        value={unidadeDose}
        icon={faDroplet}
        onChange={setUnidadeDose}
        onChangeID={setUnidadeDoseId}
        open={openUnidadeDose}
        trigger={setOpenUnidadeDose}
        items={dataUnidadeMedida}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
      <TextArea label='Observação' placeholder={''} value={observacao} onChange={setObservacao} />
    </>
  )
}